import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { FiDisplayType } from '@fi-shared/types/display-type';
import { ListData } from '@fi-app/components/items-list/list-data.service';

@Component({
    selector: 'fi-items-list-display-type-select',
    template: `
        @for (displayType of DisplayTypes; track displayType) {
          <button
            mat-button
            class="fi-items-list-display-type-button"
            [ngClass]="{ 'BrandedBackgroundColor Current': isDisplayTypeSelected(displayType.type) }"
            [disabled]="isSelectDisplayTypeDisabled()"
            (click)="selectDisplayType(displayType.type)"
            >
            <mat-icon [class]="displayType.iconClass"></mat-icon>
          </button>
        }
        `,
    styleUrls: ['./list-display-type-select.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-items-list-display-type-select' },
    standalone: false,
})
export class FiItemsListDisplayTypeSelectComponent implements OnChanges {
    @Input() model: ListData<any>;

    readonly DisplayTypes = [
        {
            type: FiDisplayType.Grid,
            iconClass: 'fas fa-th-large',
        },
        {
            type: FiDisplayType.List,
            iconClass: 'fas fa-list',
        },
    ];

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.model && this.model) this.model.raiseDisplayTypeLoaded();
    }

    isSelectDisplayTypeDisabled() {
        return !this.model;
    }

    selectDisplayType(newValue: FiDisplayType): void {
        if (newValue === this.model.DisplayType) return;
        this.model.DisplayType = newValue;
        this.model.raiseDisplayTypeChanged();
    }

    isDisplayTypeSelected(displayType: FiDisplayType): boolean {
        return this.model && this.model.DisplayType === displayType;
    }
}
